<host-base-house-relation
  #base
  (onTypeTabChange)="onTypeTabChange.emit($event)"
  (onUnlinkHouse)="onUnlink.emit()"
  (onLinkHouse)="onLink.emit()"
></host-base-house-relation>
